import { GetterTree } from "vuex";
import { RootState } from "../types";
import { ServiceScheduleState } from "./types";
import { ServiceInterface } from "@/api/Interfaces/ServiceInterface";
import { SelectTimeInterface } from "@/components/Home/Services/ServiceTimeSelect/SelectTimeInterface";
import { PatientInterface } from "@/api/Interfaces/PatientInterface";

export const getters: GetterTree<ServiceScheduleState, RootState> = {
  getTime(state): SelectTimeInterface | null {
    return state.time;
  },
  getClinicId(state): string {
    return state.clinicId;
  },
  getDate(state): string {
    return state.date;
  },
  getSearchDate(state): string {
    return state.searchDate;
  },
  getService(state): ServiceInterface | null {
    return state.service;
  },
  getCpf(state): string {
    return state.cpf;
  },
  getAppointmentDate(state): string {
    return state.appointmentDate;
  },
  getPatientData(state): PatientInterface | null {
    return state.patient;
  },
  getFormPatientData(state): { [index: string]: string | number } {
    return state.formPatientData;
  },
};
